// 'Lite' (v1) is legacy: superseded by LiteV2 and no longer assignable, so it is not offered.
// LiteV2 is presented to users simply as "Lite".
const STATS_MODE_OPTIONS = [
  { id: 'Full', name: 'Full' },
  { id: 'LiteV2', name: 'Lite' },
]

// Both Lite generations are shown to users as "Lite"; v1 lingers only on old seasons/games.
const LITE_STATS_MODES = ['Lite', 'LiteV2']

export const isLiteStatsMode = (statsMode) => LITE_STATS_MODES.includes(statsMode)

export default STATS_MODE_OPTIONS
